import { NavLink as RouterNavLink } from 'react-router-dom'
import styled, { css } from 'styled-components'

export const StyledRouterNavLink = styled(RouterNavLink)(
  ({ theme }) => css`
    line-height: 16px;

    button {
      color: ${theme.colors.white};
      font-size: ${theme.fontSizes.label};
      font-weight: 600;
      line-height: 16px;
      text-decoration: none;

      :hover {
        color: ${theme.colors.grays.N400};
      }
    }

    &.active button {
      color: ${theme.colors.turquoises.T100};
      :hover {
        color: ${theme.colors.grays.N400};
      }
    }
  `,
)
